import { createStore } from 'vuex';
import instance from '@/axios/axios.js';
import { router } from '@/router/index.js'; 

export default createStore({
  state: {
    goodsData: [], // 用于存储商品数据 
    titleText: '默认标题',
    popupText: '...',//弹出菜单标题
    popupMenuText:[],//弹出菜单选项
    isLoggedIn: localStorage.getItem('isLoggedIn'),
    token: localStorage.getItem('token'),
    userid: null,
    userInfo: [],
    // 可以考虑添加token字段
    // token: null,
  },
  mutations: {
    setGoodsData(state, data) {  
      state.goodsData = data; // 更新商品数据  
    },
    POST_GOODS_DATA(state, { ID,newdata }) {
      console.log(ID,newdata)
      state.goodsData.push({ goodsID: ID, ...newdata })
      console.log(state.goodsData)
    },
    UPDATE_GOODS_BY_ID(state, { goodsID, updates }) {
      try {
        console.log(state.goodsData)
        const itemIndex = state.goodsData.findIndex(item => item.goodsID === goodsID);
        if (itemIndex !== -1) {
          Object.assign(state.goodsData[itemIndex], updates);
        }
      } catch (error) {
        console.log(error)
      }
      
    },
    SET_USERID(state,userid) {
      state.userid = userid
    },
    updateTitle(state, newTitle) {
      state.titleText = newTitle;
    },
    updatepopupText(state, newTitle) {
      state.popupText = newTitle;
    },
    updatepopupMenuText(state, newTitle) {
      state.popupMenuText = newTitle;
    },
    SET_LOGGED_IN(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    // 假设您需要存储token
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  actions: {
    async fetchData({ commit, state }) {  
      try {  
        console.log(state.userid)
        const response = await instance.post("/allgoods",{userid: state.userid});  
        // const formattedData = response.data.map((item) => ({  
        //   ...item,  
        //   IsSelect: false,  
        //   quantity: item.quantity || 0,  
        // }));  
        console.log(response.data)
        commit('setGoodsData', response.data);  
      } catch (error) {  
        console.error('Error fetching data:', error);  
      }  
    },  
    async login({ commit }, userInfo) {
      try {
        const response = await instance.post('/login', userInfo);
        if (response.data.code === 200) {
          // 存储token（如果有的话）
          // commit('SET_TOKEN', response.data.token);
          localStorage.setItem('login_user1', JSON.stringify(response.data)); // 安全地存储用户数据
          commit('SET_LOGGED_IN', true);
          // 登录成功后，重定向到主页
          router.push('/home');
        } else {
          // 登录失败，显示错误消息或执行其他操作
          // showErrorMessage(response.data.message);
        }
      } catch (error) {
        console.error('登陆失败:', error);
        // 处理登录失败的情况，比如显示错误消息
      }
    },
    logout({ commit }) {
      // 清除localStorage中的用户数据
      localStorage.removeItem('token');
      // 清除token
      // commit('SET_TOKEN', null);
      commit('SET_LOGGED_IN', false);
      // 登出后，可以重定向到登录页面或其他页面
      router.push('/');
      // this._vm.$router.push('/login');
    },
  },
  // getters等其他选项...
});

// 在router中添加全局前置守卫来检查登录状态
// router.beforeEach((to, from, next) => {
//   const isLoggedIn = store.state.isLoggedIn; // 假设您可以从某个地方获取store实例
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth && !isLoggedIn) {
//     next('/login'); // 如果需要登录但用户未登录，重定向到登录页面
//   } else {
//     next(); // 确保一定要调用 next()
//   }
// });